import React, { useRef, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPlay, FiAlertCircle, FiExternalLink } = FiIcons;

const InlineVideo = ({ item }) => {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const startVideo = async () => {
    if (!videoRef.current) return;

    setStarted(true);
    setLoading(true);

    try {
      await videoRef.current.play();
    } catch {
      setFailed(true);
      setLoading(false);
    }
  };

  if (!item.playbackUrl) {
    return (
      <div className="relative flex aspect-video items-center justify-center overflow-hidden bg-[#152b1d]">
        {item.image && (
          <img
            src={item.image}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-70"
          />
        )}
        <div className="relative z-10 flex flex-col items-center gap-2 bg-[#1e3a29]/85 px-4 py-3 text-center">
          <SafeIcon icon={FiAlertCircle} size={20} className="text-[#d8ceb3]" />
          <span className="text-[9px] font-black uppercase tracking-widest text-[#d8ceb3]">
            Inline playback unavailable
          </span>
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-[8px] font-bold uppercase tracking-widest text-[#a9c9b1] hover:text-white"
            >
              Watch on MLB
              <SafeIcon icon={FiExternalLink} size={9} />
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="relative aspect-video overflow-hidden bg-black">
      <video
        ref={videoRef}
        src={item.playbackUrl}
        poster={item.image || undefined}
        controls={started && !failed}
        playsInline
        preload="metadata"
        aria-label={item.title}
        className="h-full w-full object-contain"
        onCanPlay={() => setLoading(false)}
        onPlaying={() => setLoading(false)}
        onError={() => {
          setFailed(true);
          setLoading(false);
        }}
      />

      {!started && !failed && (
        <button
          type="button"
          onClick={startVideo}
          aria-label={`Play ${item.title}`}
          className="absolute inset-0 flex items-center justify-center bg-black/20 transition-colors hover:bg-black/35"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-[#d8ceb3] bg-[#1e3a29]/90 text-[#d8ceb3] shadow-xl transition-transform hover:scale-110">
            <SafeIcon icon={FiPlay} size={22} className="ml-1" />
          </span>
        </button>
      )}

      {loading && !failed && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/45">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#658d71] border-t-[#d8ceb3]" />
        </div>
      )}

      {failed && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-[#152b1d] px-4 text-center">
          <SafeIcon icon={FiAlertCircle} size={22} className="text-[#e85555]" />
          <span className="text-[9px] font-black uppercase tracking-widest text-[#d8ceb3]">
            This video could not play here
          </span>
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 border border-[#d8ceb3] px-3 py-1.5 text-[8px] font-black uppercase tracking-widest text-[#d8ceb3] hover:bg-[#d8ceb3] hover:text-[#1e3a29]"
            >
              Open on MLB
              <SafeIcon icon={FiExternalLink} size={9} />
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default InlineVideo;